module.exports = __webpack_public_path__ + "img/foto-ana_gizele.251da4eb.png";